module.exports = __webpack_public_path__ + "static/media/triangolo2.3437e14b.svg";